export default __webpack_public_path__ + "static/media/hero-section.0fd9a242.png";